import styled from "styled-components";

import { fadeIn, moveUpAndFadeIn, spin } from "@/styles/Mixins";
import { IThemeProps } from "@/styles/Theme";

export const Overlay = styled.div<{ alignTop?: boolean }>`
  position: absolute;
  display: flex;
  align-items: ${(props: any) => (props.alignTop ? "flex-start" : "center")};
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: ${(props: any) => props.theme.colors.overlay};
  z-index: ${(props: any) => props.theme.zIndex.h300};
  animation: ${fadeIn} 0.15s ease-in;
`;
export const OverlayLayer = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: ${(props: any) => props.theme.zIndex.h100};
`;

export const OverlayWrapper = styled.div<{ noPadding?: boolean }>`
  position: relative;
  width: 100%;
  max-width: 540px;
  height: auto;
  max-height: 95%;
  background: #ffffff;
  overflow-y: auto;
  z-index: ${(props: any) => props.theme.zIndex.h300};
  border: 3px solid ${(props: any) => props.theme.colors.primary};
  padding: ${(props: any) =>
    props.noPadding ? 0 : props.theme.spacing.desktop.s500}px;
  opacity: 0;
  animation: ${moveUpAndFadeIn({ size: "50px" })} 250ms linear;
  animation-delay: 500ms;
  animation-fill-mode: forwards;

  @media ${(props: any) => props.theme.breakpoints.mobile} {
    width: 95vw;
    padding: ${(props: any) =>
      props.noPadding ? 0 : props.theme.spacing.desktop.s200}px;
  }
`;

export const OverlayTitle = styled.h1`
  height: 40px;
  line-height: 40px;
  font-size: ${(props: any) => props.theme.typography.h500};
  font-weight: 600;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  text-transform: uppercase;
  color: ${(props: any) => props.theme.colors.black};
  margin-bottom: ${(props: any) => props.theme.spacing.desktop.s300}px;

  @media ${(props: any) => props.theme.breakpoints.mobile} {
    margin-bottom: 0;
  }
`;

export const OverlayContent = styled.div<{ hasTopPadding: boolean }>`
  width: 100%;
  padding-top: ${(props: any) =>
    props.hasTopPadding ? props.theme.spacing.desktop.s800 : 0}px;
`;

export const OverlayClose = styled.div<{ hasImageMode: boolean }>`
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  right: 0;
  padding: ${(props: any) => props.theme.spacing.desktop.s100}px;
  margin: ${(props: any) => props.theme.spacing.desktop.s200}px;
  color: ${(props: any) =>
    props.hasImageMode ? props.theme.colors.white : props.theme.colors.black};
  background-color: ${(props: any) =>
    props.hasImageMode ? props.theme.colors.primary : "transparent"};
  cursor: pointer;
  text-align: center;
  z-index: ${(props: any) => props.theme.zIndex.h500};

  @media ${(props: any) => props.theme.breakpoints.mobile} {
    padding: 0;
    svg {
      padding: 3px;
    }
  }
`;

export const OutlinkWrapper = styled.div`
  position: relative;
`;

export const Counter = styled.span`
  font-weight: 800;
  width: 18px;
  text-align: center;
`;

export const TimerIconWrapper = styled.span`
  margin-right: 15px;
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    margin-right: 10px;
  }
`;

export const TimeoutOverlay = styled.div`
  position: absolute;
  top: -50px;
  height: 50px;
  width: 100%;
  align-items: center;
  justify-content: center;
  display: flex;
  color: ${(props: any) => props.theme.colors.black};
  text-transform: uppercase;
  font-size: 12px;

  @media ${(props: any) => props.theme.breakpoints.mobile} {
    top: -30px;
    height: 30px;
    font-size: 11px;
  }
`;

export const ImageLinkBox = styled.a`
  display: flex;
  width: 100%;
  max-height: 430px;
  font-size: ${(props: any) => props.theme.typography.h800};
  align-items: flex-start;
  justify-content: center;
  overflow: auto;
`;

export const ImageLinkLoading = styled.span`
  border-radius: 50%;
  width: 50px;
  height: 50px;
  border: 3px solid ${(props: any) => props.theme.colors.primary100};
  border-top-color: ${(props: any) => props.theme.colors.primary};
  animation: ${spin} 750ms infinite linear;
`;

export const ImageBox = styled.img`
  display: block;
  margin: 0 auto;
  max-width: 100%;
  height: auto;
  overflow: hidden;
  @media ${(props: any) => props.theme.breakpoints.mobile} {
    min-height: auto;
  }
`;

export const QuestionTitle = styled.h1`
  height: 40px;
  font-size: ${(props: any) => props.theme.typography.h500};
  font-weight: 600;
  font-stretch: normal;
  line-height: 1.38;
  letter-spacing: normal;
  text-align: center;
  color: ${(props: any) => props.theme.colors.black};
`;

export const QuestionFieldset = styled.fieldset`
  margin: 0;
  border: 0;
  padding: ${(props: any) => props.theme.spacing.desktop.s200}px;
  padding-bottom: 0;
  width: 100%;
  max-width: ${(props: any) => props.theme.globals.maxInteractionWidth};
`;

export const QuestionOption = styled.div`
  background-color: #f9f9f8;
  border: 1px solid #ffffff;
  font-size: ${(props: any) => props.theme.typography.h300};
  line-height: 1.25em;
  color: ${(props: any) => props.theme.colors.primary};
  margin-bottom: ${(props: any) => props.theme.spacing.desktop.s200}px;
  padding: ${(props: any) => props.theme.spacing.desktop.s200}px 0;
  cursor: pointer;
  text-align: center;
  font-weight: 600;

  ${(props: any) =>
    props.theme.globals.isTouch === false &&
    `&:hover {
            background-color: ${props.theme.colors.primary};
            color: ${props.theme.colors.white};
            font-weight: 800;
            padding-left: ${props.theme.spacing.desktop.s100}px;
            padding-right: ${props.theme.spacing.desktop.s100}px;
        }`}
`;

export const OutroFeedback = styled.div`
  position: relative;
  text-align: center;
  h3 {
    margin-top: ${(props: any) => props.theme.spacing.desktop.s500}px;
    margin-bottom: ${(props: any) => props.theme.spacing.desktop.s500 * 2}px;
    font-size: ${(props: any) => props.theme.typography.h700};
  }
`;

export const OutroFeedbackIcon = styled.div<{ success: boolean }>`
  display: inline-flex;
  padding: ${(props: any) => props.theme.spacing.desktop.s200}px;
  background-color: ${(props: any) =>
    props.success ? props.theme.colors.success : props.theme.colors.error};
`;

export const RegistrationStep = styled.div<{
  applyMaxHeight: boolean;
}>`
  position: relative;

  @media ${(props: any) => props.theme.breakpoints.mobile} {
    overflow-y: auto;
    padding: 15px 0;
    ${(props: any) => props.applyMaxHeight && "max-height: 400px"};
  }
`;

export const IframeWrapper = styled.div<{ width: string }>`
  margin: 0 auto;
  width: ${(props: any) => props.width}px;
`;

type OutroSlideWrapperProps = IThemeProps<{ alignTop?: boolean }>;

export const OutroSlideWrapper = styled.div<OutroSlideWrapperProps>`
  position: absolute;
  display: flex;
  align-items: ${(props: OutroSlideWrapperProps) =>
    props.alignTop ? "flex-start" : "center"};
  justify-content: center;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: ${(props: OutroSlideWrapperProps) =>
    props.theme.colors.white};
`;

type OutroSlideContentProps = IThemeProps<{ hasTopPadding?: boolean }>;

export const OutroSlideContent = styled.div<OutroSlideContentProps>`
  flex: none;
  width: 90%;
  overflow-y: scroll;
  padding-top: ${(props: OutroSlideContentProps) =>
    props.hasTopPadding ? props.theme.spacing.desktop.s800 : 0}px;
`;
